import React, { useCallback, useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import PageHeader from "../../components/PageHeader";
// import PoolCard from "../../components/PoolCard";
import PoolCardNew from "../../components/PoolCardView";
import PoolIcon from "./images/pool-icon.svg";
import { Link, useHistory } from "react-router-dom";
import { useIntervalProgressFetch } from '../../hooks/IDOPools';
import "./pools.scss";
import { getPools } from "../../services/pool";
import { toast } from "react-toastify";
import HashLoader from "react-spinners/HashLoader";
import { Context } from '../../store/store';
import { getBalanceNumber } from "../../utils/formatBalance";
import { isMobile } from 'react-device-detect' 

const Pools = () => {
    let history = useHistory();
    const upcomingPoolsHeader = {
        title: 'Upcoming Pools',
        paragraph: ''
    };
    const pastPoolsHeader = {
        title: 'Closed Pools',
        paragraph: ''
    };
    const override = `
        display: block;
        margin: auto;
    `;

    const [state, dispatch] = useContext(Context);
    const { onFetchRaised } = useIntervalProgressFetch()

    const fetchRaisedAmount = useCallback(async (activePool, pools) => {
        try {
            console.log("calleds")
            dispatch({ type: 'SET_LOADING', payload: true })
            let poolDetails = await onFetchRaised(activePool, pools)
            console.log(poolDetails)
            dispatch({ type: 'SET_LOADING', payload: false })
        } catch (e) {
            console.log(e)
            dispatch({ type: 'SET_LOADING', payload: false })
        }
    }, [onFetchRaised])

    useEffect(() => {
        console.log(state)
    }, [state])

    useEffect(() => {
        async function fetchDetails() {
            let res = await getPools()
            if (!res.status) toast.error("Oopps!, something went wrong")
            const pools: any = res.data.pools;
            console.log(pools)
            let activePool = pools.filter((item: any) => {
                return item
            })
            activePool = activePool.map((item: any) => {
                if (Number(item.closeTime) === 0 || Number(item.closeTime) * 1000 > Date.now()) {
                    item.isUpcoming = true
                    return item
                } else {
                    item.isUpcoming = false
                    return item
                }
            })
            console.log(activePool)
            fetchRaisedAmount(activePool, pools)
        }
        fetchDetails()
    }, [])

    const onPoolClick = function (poolId: string, poolAddress: string, isExculsivePool: boolean | undefined) {
        if(isExculsivePool) {
            history.push('/deadknight/exculsive')
        } else {
            history.push('/deadknight/community')
        }
    }

    return (
        <>
            <Container fluid className='brand-bgcolor-shadow-black pools-bg'>
                <PageHeader title='Upcoming IDOs' />
                <div className="container-fluid pool-list-page">
                    {state.loading && <div className="loading-container">
                        <HashLoader color={"#ffffff"} css={override} />
                    </div>}

                    {!state.loading && <div className="row justify-content-center">
                        {state.pools.map((pool: any, index: number) => (
                            <>
                                {/* {pool.isUpcoming && ( */}
                                    <>
                                        < div key={`tr-${index}`} className="col-lg-6 col-sm-12"
                                            onClick={() => { if (pool.isPoolDetailsOpenable) onPoolClick(pool.poolId, pool.poolAddress, pool.isExculsivePool) }}
                                        >
                                            <PoolCardNew
                                                openTime={pool.openTime * 1000}
                                                closeTime={pool.closeTime * 1000}
                                                title={pool.title}
                                                description={isMobile ? pool.description.slice(0, 40) + "..." : pool.description.slice(0, 70) + "..."}
                                                price={getBalanceNumber(pool.tokenPrice, 18)}
                                                symbol={pool.saleTokenSymbol}
                                                totalRaise={getBalanceNumber(pool.hardCap, 6)}
                                                tokenForSale={getBalanceNumber(pool.hardCap, 6) / getBalanceNumber(pool.tokenPrice, 18)}
                                                access={pool.access}
                                                totalCollected={pool.totalCollected ?? 0}
                                                twitter={pool.twitter}
                                                telegram={pool.telegram}
                                                website={pool.website}
                                                poolAddress={pool.poolAddress}
                                                logo={pool.logoLink}
                                                whitelistingCloseTime={pool.whitelistingCloseTime * 1000}
                                                whitelistingOpenTime={pool.whitelistingOpenTime * 1000}
                                                guaranteedDuration={pool.guaranteedDuration}
                                                whitelistingLink={pool.whitelistingLink}
                                                chainName={pool.chainName}
                                                isExculsivePool={pool.isExculsivePool}
                                                listingTime={pool.listingTime * 1000}
                                                exclusivePoolDetails={pool.exclusivePoolDetails}
                                                communityPoolDetails={pool.communityPoolDetails}
                                                pitchDeck={pool.pitchDeck}>
                                            </PoolCardNew>
                                        </div>
                                    </>
                                {/* )} */}
                            </>
                        ))}
                        {/* <SectionHeader tag="h3" data={pastPoolsHeader} className="center-content mt-5" /> */}
                        {/* {state.pools.map((pool: any, index: number) => (
                            <>
                                {!pool.isUpcoming && (
                                    <>
                                        < div key={`tr-${index}`} className="col-lg-6 col-sm-12"
                                            onClick={() => { if (pool.isPoolDetailsOpenable) onPoolClick(pool.poolId, pool.poolAddress) }}
                                        >

                                            <PoolCardNew
                                                openTime={pool.saleOpenTime * 1000}
                                                closeTime={pool.saleCloseTime * 1000}
                                                title={pool.title}
                                                description={pool.description.slice(0, 70) + "..."}
                                                price={getBalanceNumber(pool.tokenPrice, 6)}
                                                symbol={pool.saleTokenSymbol}
                                                totalRaise={getBalanceNumber(pool.hardCap, 6)}
                                                tokenForSale={getBalanceNumber(pool.totalTokens, pool.saleTokenDecimals)}
                                                access={pool.access}
                                                saleFilled="75"
                                                totalCollected={pool.totalCollected ?? 0}
                                                twitter={pool.linkTwitter}
                                                telegram={pool.linkTelegram}
                                                website={pool.linkWebsite}
                                                poolAddress={pool.poolAddress}
                                                logo={pool.linkLogo}
                                                whitelistingCloseTime={pool.whitelistingCloseTime * 1000}
                                                whitelistingOpenTime={pool.whitelistingOpenTime * 1000}
                                                guaranteedDuration={pool.guaranteedDuration}
                                                whitelistingLink={pool.whitelistingLink}
                                                chainName={pool.chainName}
                                                isExculsivePool={pool.isExculsivePool}
                                                listingTime={pool.listingTime * 1000}
                                                exclusivePoolDetails={pool.exclusivePoolDetails}
                                                communityPoolDetails={pool.communityPoolDetails}>
                                            </PoolCardNew>
                                        </div>
                                    </>
                                )}
                            </>
                        ))} */}
                    </div>
                    }
                </div>
            </Container>
        </>
    );
};

export default Pools;
